import LinearProgressBar from '@techsoftware/happay-widgets/ProgressBar/linearProgressBar';
import React from 'react'

const CustomProgressBar = (props) => {
  return (
    <LinearProgressBar {...props} />
  )
}

export default CustomProgressBar;
